/* A toast is a status, not an alert: it never steals focus and it says one
   thing at a time. */
import { useApp } from '../state/AppProvider';

export function Toast() {
  const { toast } = useApp();
  return (
    <div className={`toast${toast.visible ? ' show' : ''}`} id="toast" role="status" aria-live="polite">
      {toast.message}
    </div>
  );
}
